export interface ButtonWithLink {
  buttonLabel: string;
  linkLabel: string;
  description: string;
}
